import * as stylex from "@stylexjs/stylex";
import "@/theme/tokens.stylex";
import { colors, motion, radii } from "@/theme/tokens.stylex";
import "@/theme/type.stylex";
import { type } from "@/theme/type.stylex";
type SwitchProps = {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  labelStyle?: "body" | "eyebrow";
  xstyle?: stylex.StyleXStyles;
};
const styles = {
  row: {
    kAzted: "xbktkl8",
    kSGwAc: "xqcrz7y",
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "xou54vl",
    kmVPX3: "x1717udv",
    kMzoRj: "xc342km",
    kWkggS: "xjbqb8w",
    kMv6JI: "x17jlq2w",
    kGuDYH: "x12feioo",
    k63SB2: "xbt1u0e",
    kb6lSQ: "xhivx12",
    kMwMTN: "x1a11ngh",
    kkrTdU: "x1ypdohk",
    k9WMMc: "xdpxx8g",
    $$css: true
  },
  eyebrow: {
    kAzted: "x1gg8mnh",
    kMv6JI: "xr0iwhn",
    kGuDYH: "xucc2r2",
    k63SB2: "xo1l8bm",
    kLWn49: "x12lc5x9",
    kb6lSQ: "xlin7pe",
    kP9fke: "xtvhhri",
    $$css: true
  }
};
export function Switch({
  label,
  checked,
  onChange,
  labelStyle = "body",
  xstyle
}: SwitchProps) {
  return <button type="button" role="switch" aria-checked={checked} onClick={() => onChange(!checked)} {...stylex.props(styles.row, labelStyle === "eyebrow" && styles.eyebrow, xstyle)}>
      {label}
      <SwitchTrack checked={checked} />
    </button>;
}
export function SwitchTrack({
  checked
}: {
  checked: boolean;
}) {
  return <span aria-hidden="true" {...{
    0: {
      className: "x1n2onr6 x2lah0s x15yg21f x10w6t97 x9f619 xqhrb7l x5r8ks9 x98nf4m x106061f x16c7our x1em5f5i"
    },
    1: {
      className: "x1n2onr6 x2lah0s x15yg21f x10w6t97 x9f619 xqhrb7l x106061f x16c7our x1em5f5i x1i4uan3 x1gnnqk1"
    }
  }[!!checked << 0]}>
      <span {...{
      0: {
        className: "x10l6tqk xndqk7f xcqyyxr xvy4d1p xxk0z11 xqhrb7l x1f7iotj x49f6h5 x9ybxor x16c7our x1em5f5i"
      },
      1: {
        className: "x10l6tqk xndqk7f xvy4d1p xxk0z11 xqhrb7l x1f7iotj x49f6h5 x9ybxor x16c7our x1em5f5i x1vnjb71"
      }
    }[!!checked << 0]} />
    </span>;
}